exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-loading-wrapper-4e6e0{float:left;height:16px}.loading-loading-09baa{display:inline-block;-webkit-animation:loading-spin-ed82c .8s linear infinite;animation:loading-spin-ed82c .8s linear infinite}@-webkit-keyframes loading-spin-ed82c{0%{-webkit-transform:rotate(0);transform:rotate(0)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-spin-ed82c{0%{-webkit-transform:rotate(0);transform:rotate(0)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// Exports
exports.locals = {
	"loading-wrapper": "loading-loading-wrapper-4e6e0",
	"loadingWrapper": "loading-loading-wrapper-4e6e0",
	"loading": "loading-loading-09baa",
	"spin": "loading-spin-ed82c"
};